// Progress timeline for recipe instructions: clicking a circle marks all steps
// up to and including it as done. (Mirrors the original inline behavior exactly.)
const DEFAULT_COLOR = '#ccc';
const ACTIVE_COLOR = '#D82435';

function initTimeline(selector) {
  const items = document.querySelectorAll(selector);

  items.forEach((item, index) => {
    const line = item.querySelector('.vertical-line');
    const circle = item.querySelector('.custom-checkbox-circle');
    const description = item.querySelector('.checkbox-description');
    if (!circle || !description) return;

    // Match the connecting line height to the step description.
    if (line) line.style.height = `${description.offsetHeight}px`;

    circle.addEventListener('click', () => {
      const clickedNumber = index + 1;
      const isActive = circle.classList.contains('active');

      items.forEach((otherItem, otherIndex) => {
        const otherCircle = otherItem.querySelector('.custom-checkbox-circle');
        const otherLine = otherItem.querySelector('.vertical-line');
        if (!otherCircle || !otherLine) return;

        if (otherIndex < clickedNumber) {
          otherCircle.style.backgroundColor = ACTIVE_COLOR;
          otherLine.style.backgroundColor = ACTIVE_COLOR;
          otherCircle.classList.add('active');
          otherLine.classList.add('active');
        } else if (otherIndex === clickedNumber - 1) {
          if (isActive) {
            otherCircle.style.backgroundColor = 'transparent';
            otherLine.style.backgroundColor = DEFAULT_COLOR;
            otherCircle.classList.remove('active');
            otherLine.classList.remove('active');
          } else {
            otherCircle.style.backgroundColor = ACTIVE_COLOR;
            otherLine.style.backgroundColor = ACTIVE_COLOR;
            otherCircle.classList.add('active');
            otherLine.classList.add('active');
          }
        } else {
          otherCircle.style.backgroundColor = 'transparent';
          otherLine.style.backgroundColor = DEFAULT_COLOR;
          otherCircle.classList.remove('active');
          otherLine.classList.remove('active');
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initTimeline('.timeline-item');
  initTimeline('.secondary-timeline-item');
});
